import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TimelineReelConfig} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelConfig";
import {IReelStoppedData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TombOfAkhenatenReelController} from "./TombOfAkhenatenReelController";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {TombOfAkhenatenReelSymbol} from "../symbols/TombOfAkhenatenReelSymbol";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {TOAGameRoundManager} from "../gameround/TOAGameRoundManager";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {SoundManager} from "../sound/SoundManager";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SpinningPyramid} from "../feature/SpinningPyramid";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {SpinStart} from "../gameround/spin/SpinStart";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

interface TOAGameRoundSequence {
    customStarting: GameRoundPresentation[];
    idle: GameRoundPresentation[];
    idleLoop: GameRoundPresentation[];
    starting: GameRoundPresentation[];
    stoppable: GameRoundPresentation[];
    skippable: GameRoundPresentation[][];
}

export class TOATimelineReelsController extends TimelineReelsController {
    public _isFinalReSpin: boolean = false;
    public _isFSFinalReSpin: boolean = false;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    private _oldGameData: ParsedServerData;
    public isHighlightWinSymOnLandForFinalSpin: boolean[] = [];
    public reelWinPositions: boolean[] = [];
    public _stickySymArr: boolean[] = [];
    public _isNextFinalSpin: boolean = false;
    public nearWinReels: boolean[] = [];
    private _finalSpinWildPositions: number[] = [];
    public lastPyramidReelIdArr: number[] = [];
    private _pyramidExpandingTl: TimelineLite[] = [];
    private _isAbort: boolean = false;
    public finalSpinActiveReels: number[] = [];
    public prevFinalSpinActiveReels: number[] = [];

    private _reelStartArr: GameRoundPresentation [] = [];
    private _fsReelStartArr: GameRoundPresentation [] = [];
    private _scatterCounter: number = 0;
    private _finalReelsWithStickyArr: string[] = [];
    private _isBonusGame: boolean = false;
    public is5x3Reel : boolean = false;

    constructor() {
        super();
    }

    init(gameRoundConfig: GameRoundConfig) {
        this._reelStartArr = (<TOAGameRoundSequence>gameRoundConfig.RESPIN_FINAL).customStarting;
        this._fsReelStartArr = (<TOAGameRoundSequence>gameRoundConfig.FS_RESPIN_FINAL).customStarting;
    }

    protected addEventListeners() {
        super.addEventListeners();
        EventHandler.addFirstEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onNewGameRound());
        EventHandler.addEventListener(this, TOAGameEvent.ON_SPIN_ABORT, () => this.onSpinAbort());
        EventHandler.addEventListener(this, TOAGameEvent.ALL_PYRAMID_STOPPED, () => this.playCustomStarting());
        EventHandler.addEventListener(this, TOAGameEvent.ALL_SPIN_STOP_COMPLETE, () => {
            if (this._isFinalReSpin && this._isAbort) {
                this._pyramidExpandingTl.forEach((tl) => {
                    if (tl?.isActive()) {
                        tl.progress(1);
                    }
                });
                this._pyramidExpandingTl.length = 0;
            }
            SoundManager.stopReelSpinningSound();
        });

    }

    private onSpinAbort() {
        this._isAbort = true;
    }

    private onNewGameRound() {
        this._stickySymArr.length = 0;
        this._isFinalReSpin = false;
        this._isFSFinalReSpin = false;
        this._scatterCounter = 0;
        this._isNextFinalSpin = false;
        this.finalSpinActiveReels = [5, 5, 5, 5, 5];
        this.is5x3Reel = this._gameData.activeRowsNextSpin === 3 && this._gameData.activeRows == 3;
        const pyramidLayer: ScalableLayer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name);
        pyramidLayer.children.forEach((child) => {
            if (child instanceof TimelineSprite) {
                child.stopLoop();
                child.hide();
            }
        });
        pyramidLayer.removeChildren();
    }

    private onInitDataParsed(data: TombOfAkhenatenParsedInitData): void {
        this._oldGameData = data;
        this._gameData = data;
        this._isBonusGame = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.mode) > -1;
        this.setSticky(data.stickySymbols);
    }

    private setSticky(stickySymbols: string[][]) {
        this.finalSpinActiveReels = [5, 5, 5, 5, 5];
        this._stickySymArr.length = 0;
        stickySymbols.forEach((symArr, reelId) => {
            this._stickySymArr.push(symArr[0] != "X");
            if (symArr[0] != "X") {
                this.finalSpinActiveReels[Math.floor(reelId / 5)]--;
            }
        });
    }

    protected onReelSpinStopped(reelId: number) {
        const sym = Reels.getSymbol(reelId, 0)
        let symbolName = sym?.symName;
        if (symbolName == "W2" && this.lastPyramidReelIdArr.indexOf(reelId) > -1 && this._isFinalReSpin) {
            const currReelArr = TombOfAkhenatenGameModuleConfig.reelArr[Math.floor(reelId / 5)];
            currReelArr.forEach((reelId) => {
                this.removePyramidAnticipationFire(reelId);
            })
            const fromReelId = reelId;
            const toReelId = currReelArr[0];
            const tl: TimelineLite = new TimelineLite();
            for (let i = fromReelId - 1; i >= toReelId; i--) {
                const startTime: number = Math.abs(fromReelId - i - 1) * 0.3;
                if (this._finalSpinWildPositions.indexOf(i) > -1 /*&& this._gameData.reels[i].indexOf("W2") == -1*/) {
                    tl.add(this.replaceWild2Sym(i), startTime);
                } else if ((<TombOfAkhenatenParsedGameData>this._gameData).evaluatedArea[Math.floor(i / 5)][i % 5] == "W") {
                    tl.add(this.playX2WildAnimation(i), startTime);
                }
            }
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PYRAMID_EXPANDING_WILD_ANIM_COMPLETE, Math.floor(reelId / 5)));
            });
            this._pyramidExpandingTl.push(tl);
            if (!this.reelWinPositions[reelId]) {
                //Logger.logDev("onReelSpinStopped increased pyramidExpandingTl timescale for reelId : " + reelId);
                tl.timeScale(5);
            }
        } else {
            this.removePyramidAnticipationFire(reelId);
        }
        let isBonusGame: boolean = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.mode) > -1;
        if (!isBonusGame && this._gameData.nextMode === TombOfAkhenatenGameMode.NORMAL) {
            if (this._stickySymArr.lastIndexOf(false) === reelId) {
                //handling for last reel stopped goes here
                if ((<TombOfAkhenatenParsedGameData>this._gameData).isBigWin) {
                    SoundManager.stopMainGameRespinBgSounds(1500);
                } else {
                    SoundManager.stopMainGameRespinBgSounds(10000);
                }
            }
        }

        super.onReelSpinStopped(reelId);
    }

    private isFreeSpin(): boolean {
        return this._gameData.mode == TombOfAkhenatenGameMode.FREESPIN || this._gameData.mode == TombOfAkhenatenGameMode.FS_RESPIN_FIRST ||
            this._gameData.mode == TombOfAkhenatenGameMode.FS_RESPIN_SECOND || this._gameData.mode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL;
    }

    private setHighlightWinSymInLandArr(col: number) {
        for (let i = col * 5; i < 5 * (col + 1); i++) {
            this.isHighlightWinSymOnLandForFinalSpin[i] = true;
        }
    }

    private isStickyWildOnCol(col: number) {
        return this.getStickySymArrOnColumn(col).indexOf("W") > -1;
    }
    private isWildOnCol(col: number){
        return this.isStickyWildOnCol(col) || this.isPyramidOnCol(col);
    }
    private isPyramidOnCol(col: number) {
        return (this._gameData as TombOfAkhenatenParsedGameData).pyramidReelLand[col];
    }

    private isStickySymOnCol(col: number, symName: string) {
        //added pyramid wild condition
        return this.getStickySymArrOnColumn(col).indexOf(symName) > -1 || this.isPyramidOnCol(col);
    }

    private isSymOnCol(col: number, symName: string) {
        const symArr: string[] = (this._finalReelsWithStickyArr.slice(col * 5, (col + 1) * 5));//.map((symArr) => symArr[0]);
        //added pyramid wild condition
        return symArr.indexOf(symName) > -1 || symArr.indexOf("W") > -1 || this.isPyramidOnCol(col);
    }

    private getStickySymArrOnColumn(col: number): string[] {
        return (this._gameData.stickySymbols.slice(col * 5, (col + 1) * 5)).map((symArr) => symArr[0]);
    }

    public stopSpin(reelId: number, data: TombOfAkhenatenParsedGameData, quickStop: boolean = false, stopSpinData?: IReelStopSpinData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const reelConfig: TimelineReelConfig = this.getReelConfig(reelId);
        const reel: SpinReelController = <SpinReelController>Reels._reels[reelId];

        if (reel.currentState === ReelAnimationState.STOP_SPIN) {
            tl.add(new TweenLite(this, reel.currentSpinStepLeftTime, {}));
            return tl;
        }

        const stopData: IReelStopSpinData = stopSpinData != undefined ? stopSpinData : {
            quickStop: quickStop,
            fastSpin: GameSetting.isFastSpin,
            active: true,
            spinStopOffset: 0, //send 0 here, can be modified as usual in the reelsController.
        };
        const duration: number = (GameSetting.isFastSpin || quickStop) ? reelConfig.quickStopDuration : reelConfig.stopDuration;
        tl.eventCallback("onStart", () => {
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, reelId)); //The reel is listening and waiting for this event for it to complete. Because we don't have this type of presentations anymore, this is just dispatched here to make things work.
            stopData.spinStopOffset = reel.getSpinStopOffset();

            const stopDuration = reel.stopSpin(stopData, 0);
            tl.add(new TweenLite(this, stopDuration, {}), 0);
        });
        tl.add(new TweenLite(this, duration, {}), 0);

        tl.add(() => {
            //Sometimes the reelPartAnimator stop ever so slightly later that this animation. The time diff is usually less than 0.04 seconds. I guess it's caused by  this._reels[reelId].stopSpin calculation is not perfect, loosing some decimals somewhere. Or the shifting is not perfect.
            //This anyway makes sure that the reels exit spin state before the animation completes.
            if (reel.currentState === ReelAnimationState.STOP_SPIN) {
                let dur = reel.currentSpinStepLeftTime;
                dur += 0.05;
                if (dur > 0) {
                    tl.add(new TweenLite(this, dur, {}));
                }
            }
        });
        return tl;
    }

    private onServerDataParsed(data: TombOfAkhenatenParsedGameData): void {
        this._isAbort = false;
        this.reelWinPositions.length = 0;
        this._finalReelsWithStickyArr.length = 0;
        this._oldGameData = this._gameData;
        this._gameData = data;
        this.is5x3Reel = false;
        this._isBonusGame = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.mode) > -1;

        this.nearWinReels = data.nearWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
        for (let i = 0; i < data.pyramidReelLand.length; i++) {
            this.lastPyramidReelIdArr[i] = -1;
            if (data.pyramidReelLand[i]) {
                const lastIndex: number = this._gameData.evaluatedArea[i].lastIndexOf("W2");
                if (lastIndex != -1) {
                    this.lastPyramidReelIdArr[i] = 5 * i + lastIndex;
                }
            }
        }
        this.setSticky(data.stickySymbols);
        data.reels.forEach((symArr, reelId) => {
            if (data.stickySymbols[reelId][0] !== "X") {
                this._finalReelsWithStickyArr[reelId] = data.stickySymbols[reelId][0];
            } else {
                this._finalReelsWithStickyArr[reelId] = data.reels[reelId][0];
            }
        });
        const currentBetWinData = this._gameData.betWins;
        for (let i: number = 0; i < currentBetWinData.length; i++) {
            const reelWinPos = (currentBetWinData[i] as IBetWayWinData).reelWinPositions;
            reelWinPos.forEach((arr, col) => {
                arr.forEach((value, row) => {
                    const index = col * 5 + row;
                    this.reelWinPositions[index] = this.reelWinPositions[index] ? this.reelWinPositions[index] || value : value;
                })
            });
        }
        this.isHighlightWinSymOnLandForFinalSpin = ArrayHelper.initArrayWithValues(25, () => false);
        this._isFinalReSpin = data.mode.indexOf("FINAL") > -1;
        this._isFSFinalReSpin = data.mode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL;
        this._isNextFinalSpin = data.nextMode.indexOf("FINAL") > -1;
        if (this._isFinalReSpin) {
            if (this.isWildOnCol(1) && this.isWildOnCol(2)) {
                this.setHighlightWinSymInLandArr(0);
            }
            if (this.isWildOnCol(0) && this.isWildOnCol(2)) {
                this.setHighlightWinSymInLandArr(1);
            }
            // if (this.isStickyWildOnCol(0) && this.isStickyWildOnCol(1)) {
            //     this.setHighlightWinSymInLandArr(2);
            // }

            TombOfAkhenatenGameModuleConfig.reelArr[0].forEach((reelId) => {
                if (!this._stickySymArr[reelId]) {
                    const symName = data.reels[reelId][0];
                    if (symName == "W" && (this.isStickySymOnCol(1, symName) || this.isStickySymOnCol(2, symName))) {
                        this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
                    } else if (this.isStickySymOnCol(1, symName) && this.isStickySymOnCol(2, symName)) {
                        this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
                    }
                }
            });

            TombOfAkhenatenGameModuleConfig.reelArr[1].forEach((reelId) => {
                if (!this._stickySymArr[reelId]) {
                    const symName = data.reels[reelId][0];
                    if (symName == "W" && (this.isSymOnCol(0, symName) || this.isStickySymOnCol(2, symName))) {
                        this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
                    } else if (this.isSymOnCol(0, symName) && this.isStickySymOnCol(2, symName)) {
                        this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
                    }
                }
            });

            // TombOfAkhenatenGameModuleConfig.reelArr[2].forEach((reelId) => {
            //     if (!this._stickySymArr[reelId]) {
            //         const symName = data.reels[reelId][0];
            //         if(symName == "W" && (this.isSymOnCol(0, symName) && this.isSymOnCol(1, symName))){
            //             this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
            //         }else if (this.isSymOnCol(0, symName) && this.isSymOnCol(1, symName)) {
            //             this.isHighlightWinSymOnLandForFinalSpin[reelId] = true;
            //         }
            //     }
            // });
            this.setHighlightWinSymInLandArr(2);
            this.setHighlightWinSymInLandArr(3);
            this.setHighlightWinSymInLandArr(4);
        }


        this._finalSpinWildPositions.length = 0;
        for (let i = 0; i < data.finalSpinWildPositions.length; i++) {
            const reelId: number = data.finalSpinWildPositions[i][0] * 5 + data.finalSpinWildPositions[i][1];
            if (this._finalSpinWildPositions.indexOf(reelId) == -1) {
                this._finalSpinWildPositions.push(reelId);
            }
        }
        if (this._isFinalReSpin) {
            this._pyramidExpandingTl.length = 0;
        }
        //Logger.logDev("isHighlightWinSymOnLandForFinalSpin is ", this.isHighlightWinSymOnLandForFinalSpin);
        //Logger.logDev("_finalReelsWithStickyArr is ", this._finalReelsWithStickyArr);
    }

    private removePyramidAnticipationFire(reelId: number) {
        if (SpinningPyramid.reelFireFrameArr.get(reelId)) {
            const tlSpriteArr = SpinningPyramid.reelFireFrameArr.get(reelId);
            tlSpriteArr?.forEach((tlSprite) => {
                TweenLite.to(tlSprite, 0.2, {
                    alpha: 0, onComplete: () => {
                        if (tlSprite instanceof TimelineSprite) {
                            (<TimelineSprite>tlSprite).stopLoop();
                            (<TimelineSprite>tlSprite).hide();
                        }
                        if (tlSprite instanceof PIXI.Sprite) {
                            (<PIXI.Sprite>tlSprite).alpha = 0;
                        }
                        SpinningPyramid.reelFireFrameArr.delete(reelId);
                        this.isAllAnticipationFireRemoved();
                    }
                });
            });
        }
    }

    private isAllAnticipationFireRemoved() {
        if (!SpinningPyramid.reelFireFrameArr.size) {
            TombOfAkhenatenGameModuleConfig.spinningPyramidController.stopFireAnticipationSound();
        }
    }

    private playX2Anim(pos: number[], reelId: number): TimelineLite {
        let reelController = Reels.getReel(reelId);

        const timeline: TimelineLite = new TimelineLite();
        const x2Ring: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("x2Ring")[0]);
        x2Ring.alpha = 0;
        x2Ring.anchor.set(0.5, 0.5);
        if (reelController) {
            (<TombOfAkhenatenReelController>reelController)._x2OnWild = x2Ring;
        }

        const hotZoneBlast = new TimelineSprite(GameResources.getTextures("hotZoneBlast"));
        hotZoneBlast.blendMode = PIXI.BLEND_MODES.ADD;
        hotZoneBlast.anchor.set(0.5);
        hotZoneBlast.hide();
        hotZoneBlast.position.set(pos[0], pos[1] + 100);
        x2Ring.position.set(pos[0], pos[1] + 100);
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name).addChild(x2Ring, hotZoneBlast);
        timeline.add([
            TweenLite.to(x2Ring, 0.001, {alpha: 1}),
            TweenLite.fromTo(x2Ring.scale, 0.2, {x: 0, y: 0}, {x: 1.2, y: 1.2}),
            () => {
                hotZoneBlast.show();
                hotZoneBlast.getAnimationAutoShowHide(true, false);
            }
        ], 0.5);
        timeline.add(TweenLite.to(x2Ring.scale, 0.2, {x: 1, y: 1}));

        return timeline;
    }

    private playX2WildAnimation(reelId: number) {
        const timeline: TimelineLite = new TimelineLite();
        let reelController = Reels.getReel(reelId);
        if (reelController) {
            const wildBlastSprite: TimelineSprite = new TimelineSprite(GameResources.getTextures("wildBlast"));
            wildBlastSprite.blendMode = PIXI.BLEND_MODES.ADD;
            wildBlastSprite.anchor.set(0.5);
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name).addChild(wildBlastSprite);
            wildBlastSprite.pivot.y = -45;
            timeline.add(() => {
                const reelSym = Reels.getSymbol(reelId, 0);
                if (reelController && reelSym) {
                    wildBlastSprite.position.set(reelController.view.position.x, reelController.view.position.y + reelSym.position.y);
                    EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PYRAMID_X2_BLAST_ANIM, Math.floor(reelId / 5)))
                    if (!this._isAbort) {
                        this.playExplosionSoundForReelId(reelId);
                    } else {
                        this.stopExplosionSound();
                        this.playExplosionSoundForReelId(reelId);
                    }
                    this.playX2Anim([reelController.view.position.x, reelController.view.position.y + reelSym.position.y], reelId)
                }
            })
            let frameArr: number[] = [];
            for (let i = 14; i <= 33; i++) {
                frameArr.push(i);
            }
            timeline.add(() => {
                wildBlastSprite.getAnimationAutoShowHide(true, true, frameArr);
            });
        }

        return timeline;
    }

    private playExplosionSoundForReelId(reelId: number) {
        if (!this.reelWinPositions[reelId]) {
            TombOfAkhenatenGameModuleConfig.spinningPyramidController.playExplosionSoftSound();
        } else {
            TombOfAkhenatenGameModuleConfig.spinningPyramidController.playExplosionSound();
        }
    }

    private stopExplosionSound() {
        TombOfAkhenatenGameModuleConfig.spinningPyramidController.stopExplosionSound();
        TombOfAkhenatenGameModuleConfig.spinningPyramidController.stopExplosionSoftSound();
    }

    private replaceWild2Sym(reelId: number): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        let reelController = Reels.getReel(reelId);
        if (reelController) {
            const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset("pyramidWild"),
                spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
            spine.alpha = 0;
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name).addChild(spine);
            spine.pivot.y = -45;

            timeline.add(() => {
                let wildSym = new TombOfAkhenatenReelSymbol("W2", reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal);
                const reelSym = reelController?.allSymbols.pop();
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.REMOVE_SYM_STATE_FIRE, reelId));
                if (reelController && reelSym) {
                    spine.position.set(reelController.view.position.x, reelController.view.position.y + reelSym.position.y);
                    wildSym.position.set(reelSym.position.x, reelSym.position.y);
                    wildSym.alpha = 0;

                    reelSym.parent?.addChild(wildSym);
                    reelSym.visible = false;
                    wildSym.visible = true;
                    reelController.removedChildOnView(reelSym)
                    reelController.allSymbols.push(wildSym);
                    if (!this.isFreeSpin() && TombOfAkhenatenReelController.SCATTER_COUNT > 1) {
                        if (this.reelWinPositions[reelId]) {
                            spine.tint = 0xadadad;
                            TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(reelId, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!);
                        } else {
                            TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(reelId, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin!);
                        }
                    } else if (this.reelWinPositions[reelId]) {
                        //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword));
                    } else {
                        TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(reelId, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin!);
                    }
                    EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PYRAMID_X2_BLAST_ANIM, Math.floor(reelId / 5)));
                    if (!this._isAbort) {
                        this.playExplosionSoundForReelId(reelId);
                    } else {
                        this.stopExplosionSound();
                        this.playExplosionSoundForReelId(reelId);
                    }
                }
                // let colWiseReelArr = TombOfAkhenatenGameModuleConfig.reelArr[Math.floor(reelId / 5)];
                // colWiseReelArr.forEach((reelId) => {
                //     let reelController = Reels.getReel(reelId);
                //     (reelController as TombOfAkhenatenReelController).reOrderSymbols(true)
                // });
                (reelController as TombOfAkhenatenReelController).reOrderSymbols(true);
                TweenLite.to(spine, 0.001, {alpha: 1})
                TweenLite.to(wildSym, 0.3, {alpha: 1})
            }, 0);

            timeline.add(new SpineTween(spine, 0, "W2_animation", 0));
            timeline.add(TweenLite.to(spine, 0.001, {alpha: 0}), 0.7);
            timeline.add(() => {
                spine.parent?.removeChild(spine);
            })
        }
        return timeline;
    }


    onStartSpin(reelId: number, isSticky: boolean = false): gsap.TimelineLite | null {
        return isSticky ? null : this.startSpin(reelId);
    }

    public startSpin(reelId: number): TimelineLite {
        const reelConfig: TimelineReelConfig = this.getReelConfig(reelId);
        const durationPadding = 0.1;
        const shouldPlayPyramidSpin: boolean = this.finalSpinActiveReels[Math.floor(reelId / 5)] > 0;
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                if ((this._isNextFinalSpin || this._isFinalReSpin)) {
                    //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.START_PYRAMID_SPINNING, Math.floor(reelId / 5), shouldPlayPyramidSpin));
                }
                Reels._reels[reelId].startSpin({
                    active: true,
                    fastSpin: GameSetting.isFastSpin
                }, 0);
            }
        });
        tl.add(new TweenLite(this, reelConfig.startDuration + durationPadding, {}));
        return tl;
    }

    private playCustomStarting() {
        //Logger.logDev("SpinningPyramid All Spinning pyramid spinning complete playCustomStarting");
        if (this._isFinalReSpin) {
            if (!this._isBonusGame) {
                SoundManager.playMainGameRespinFinalBgSound();
            }
            //#355
            //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_MULTIPLIER, this._gameData.payoutMultiplier, this._isAbort));
            const tl = new TimelineLite({
                onComplete: () => {
                    (TombOfAkhenaten.gameRoundManager as TOAGameRoundManager).onAllCustomFinalSpinStarted(<TombOfAkhenatenParsedGameData>this._gameData);
                }
            });
            tl.add(this.createStateTimeline(this._oldGameData, this._isFSFinalReSpin ? this._fsReelStartArr : this._reelStartArr));
            !SpinStart.isFullStickyReel && tl.add(TweenLite.to({}, 0.5, {})); //delay added to increase a gap between start and stop.
        }
    }

    private addControlState(animation: Timeline, presentation: GameRoundPresentation): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const control = {
            presentation: presentation,
            state: PresentationState.INACTIVE,
            tl: tl
        };
        tl.add(animation);
        tl.eventCallback("onStart", () => {
            control.state = PresentationState.ACTIVE;
        });
        tl.eventCallback("onComplete", () => {
            control.state = PresentationState.DONE;
        });
        return tl;
    }

    //Timeline creation
    private createStateTimeline(data: ParsedServerData, presentations: GameRoundPresentation[]): TimelineLite | null {
        let tl: TimelineLite | null = null;
        let startTime: number = 0;

        for (let presentation of presentations) {
            if (presentation.prepare) {
                presentation.prepare(data);
            }

            const presentationAnimation: Timeline | null = presentation.getAnimation(data);
            if (presentationAnimation == null) {
                continue;
            }

            if (tl == null) {
                tl = new TimelineLite();
            }

            const controlTl = this.addControlState(presentationAnimation, presentation);
            tl.add(controlTl, startTime);
            //Timing control.
            let delay: number = controlTl.duration();

            if (presentation.stagger != undefined && presentation.stagger >= 0) {
                delay = presentation.stagger;
            }

            startTime += delay;
            if (SpinStart.isFullStickyReel) {
                startTime = 0;
            }
        }
        return tl;
    }

    private hideBlurSym(reelId : number, symName : string){
        const reelController = Reels.getReel(reelId);
        reelController?.allSymbols.forEach((sym)=>{
            if(sym.symName != symName){
                sym.setVisibility(false);
            }
        });
    }
    protected onReelBounceStarted(stopData: IReelStoppedData) {
        let isBonusGame: boolean = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.mode) > -1;
        const sym = Reels.getSymbol(stopData.reelId, 0)
        let symbolName = sym?.symName;
        if (symbolName == "S") {
            this.hideBlurSym(stopData.reelId, symbolName);
            this._scatterCounter++;
            //#302
            SoundManager.playScatterLandingSound(this._scatterCounter, isBonusGame);
        } else if (symbolName == "W2") {
            TombOfAkhenatenGameModuleConfig.spinningPyramidController.playWildLandingSound();
        } else if (symbolName == "W") {
            this.hideBlurSym(stopData.reelId, symbolName);
            SoundManager.playNormalWildLandingSound();
        }

        if ((this._gameData.mode == GameMode.NORMAL || this._gameData.mode == GameMode.FREESPIN) && this._scatterCounter < 2) {
            if (stopData.reelId == 4 || stopData.reelId == 9 || stopData.reelId == 14 || stopData.reelId == 19 || stopData.reelId == 24) {
                SoundManager.playReelLandingSound();
            }
        } else {
            SoundManager.playReelLandingSound();
        }

        if (!(<TombOfAkhenatenParsedGameData>this._gameData).wasFeatureBuy &&
            (this._gameData.nextMode === TombOfAkhenatenGameMode.NORMAL || this._gameData.nextMode === TombOfAkhenatenGameMode.FREESPIN)) {
            if (stopData.reelId === this.nearWinReels.lastIndexOf(true)) {
                SoundManager.stopScatterAnticipationSound();
                if (TombOfAkhenatenReelController.SCATTER_COUNT === 2) {
                    SoundManager.playScatterAnticipationFailSound();
                }
            }
        }
        super.onReelBounceStarted(stopData);
    }


    setFakeReel() {
        for (let i: number = 0; i < 25; i++) {
            (Reels._reels[i] as TombOfAkhenatenReelController).setFakeReel();
        }
    }
}

enum PresentationState {
    INACTIVE = 0,
    ACTIVE,
    DONE
}